import React, { useCallback } from 'react';
import { CubeIcon } from '@phosphor-icons/react';
import {
    showSiteViewerUnavailableModal,
    useSiteViewer3dBlocked,
} from '../../../../../helpers/siteViewer3dAccess';

interface DashboardAiRailPeekButtonProps {
    aiRailOpen: boolean;
    /** Peek only appears when the full dashboard overlay is open. */
    isDashboardOpen: boolean;
    theme: 'dark' | 'light';
    /** Close dashboard, go to roof / 3D configure view. */
    onView3d: () => void;
}

/** Right-edge peek on the full dashboard: switch to 3D roof viewer (replaces former “Designs” rail opener). */
export const DashboardAiRailPeekButton: React.FC<DashboardAiRailPeekButtonProps> = ({
    aiRailOpen,
    isDashboardOpen,
    theme,
    onView3d,
}) => {
    const { blocked: viewer3dBlocked, message: blockedMessage } = useSiteViewer3dBlocked();

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            e.stopPropagation();
            if (viewer3dBlocked) {
                showSiteViewerUnavailableModal(blockedMessage);
                return;
            }
            onView3d();
        },
        [viewer3dBlocked, blockedMessage, onView3d]
    );

    if (!isDashboardOpen || aiRailOpen) return null;

    return (
        <button
            type="button"
            className={`obd-ai-rail__peek obd-theme-${theme}${viewer3dBlocked ? ' obd-ai-rail__peek--blocked' : ''}`}
            onClick={handleClick}
            aria-label={viewer3dBlocked ? '3D viewer unavailable — click for details' : 'View 3D'}
            title={
                viewer3dBlocked
                    ? '3D viewer unavailable — click for details'
                    : 'Open 3D Viewer'
            }
        >
            <CubeIcon size={22} weight="duotone" aria-hidden />
            <span>oneDRAW</span>
        </button>
    );
};
